<template>
  <div class="logo bg-white">
    <img :src="logoSvg" />
    <img :src="logoTextSvg" class="logo-text" v-if="!getCollapsed && !isDark" />
    <img
      :src="logoLightTextSvg"
      class="logo-text"
      v-if="!getCollapsed && isDark"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import logoSvg from "/@/assets/images/logo.svg";
import logoTextSvg from "/@/assets/images/logo-text.svg";
import logoLightTextSvg from "/@/assets/images/logo-light-text.svg";
import { useRootSetting } from "/@/hooks/setting/useRootSetting";
import { ThemeEnum } from "/@/enums/appEnum";

const { getDarkMode } = useRootSetting();

import { useMenuSetting } from "/@/hooks/setting/useMenuSetting";
const { getCollapsed } = useMenuSetting();
const isDark = computed(() => getDarkMode.value === ThemeEnum.DARK);
console.log(logoTextSvg);
</script>
<style lang="less" scoped>
.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 48px;
  text-align: center;
  justify-content: center;
  border-bottom: 1px solid @border-color-light;
  box-sizing: border-box;
  img {
    width: 32px;
    flex-shrink: 0;
  }
  .logo-text {
    width: 64px;
    margin-left: 12px;
  }
}
</style>
